import { useMutation } from '@tanstack/react-query';

import { $apiWithoutClient, errorHandler } from 'modules/global';

export function useCheckOlympicTest() {
  return useMutation({
    mutationFn: async ({ testId, optionId }: { testId?: number; optionId?: number | null }) => {
      const { data } = await $apiWithoutClient.post(`/olympic/check-test`, { id: testId, option_id: optionId });

      return data;
    },
    onError: errorHandler()
  });
}
